var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal } from 'src/ui/components/modal/Modal';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { Select } from 'src/ui/components/Input/Select/Select';
import { SelectSection } from 'src/ui/components/Input/SelectSection/SelectSection';
import { TextInput } from 'src/ui/components/Input/TextInput/TextInput';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { getApplicantDisplayOption, getApplicantFromOption } from '../helpers';
import styles from './IncompleteIdentityModal.module.scss';
export var IncompleteIdentityModal = function (props) {
    var i18n = props.i18n, title = props.title, reasons = props.reasons, applicants = props.applicants, _a = props.allApplicants, allApplicants = _a === void 0 ? [] : _a, confirmButton = props.confirmButton, isLoading = props.isLoading, onCancel = props.onCancel, onValidate = props.onValidate;
    var _b = useState(applicants[0]), currentApplicant = _b[0], setCurrentApplicant = _b[1];
    var _c = useState(null), currentReason = _c[0], setCurrentReason = _c[1];
    var _d = useState(''), searchValue = _d[0], setSearchValue = _d[1];
    var labelCancelButton = getPropsByKeyPath(i18n, 'modules.identityIncomplete.cancelButtonLabel');
    var labelConfirmButton = confirmButton.label || getPropsByKeyPath(i18n, 'modules.identityIncomplete.submitButtonLabel');
    var searchPlaceholder = getPropsByKeyPath(i18n, 'modules.identityIncomplete.searchPlaceholder');
    var applicantLabel = getPropsByKeyPath(i18n, 'modules.identityIncomplete.applicantLabel');
    var reasonsFiltered = reasons.filter(function (reason) {
        return reason.label.toLowerCase().includes(searchValue.toLowerCase()) ||
            reason.code.toLowerCase().includes(searchValue.toLowerCase());
    });
    var reasonsLabel = reasonsFiltered.map(function (reason) { return reason.label; });
    var handleSelectCurrentItem = function (selectedOption) {
        // We can't set empty value in select component
        if (selectedOption) {
            var applicant = getApplicantFromOption(selectedOption, applicants, allApplicants);
            if (applicant) {
                setCurrentApplicant(applicant);
            }
        }
    };
    var handleReasonChange = function (reason) {
        var reasonSelected = reasons.find(function (r) { return r.label === reason; });
        setCurrentReason(reasonSelected);
    };
    var handleConfirmIncompleteIdentity = function () {
        if (currentApplicant) {
            if (currentReason) {
                onValidate({ applicantId: currentApplicant.id, reasonCode: currentReason.code });
            }
        }
        else {
            console.error('Error no applicant selected');
        }
    };
    var applicantsOptions = applicants.map(function (app) { return getApplicantDisplayOption(app, applicants, allApplicants); });
    var currentApplicantOption = currentApplicant
        ? getApplicantDisplayOption(currentApplicant, applicants, allApplicants)
        : '';
    return (_jsxs(Modal, __assign({ title: title, className: styles.incompleteIdentityModalWrapper, onClose: onCancel, color: COLORS.PRIMARY['500'] }, { children: [_jsxs("div", __assign({ className: styles.incompleteIdentityModalContent }, { children: [_jsx(Select, { disabled: applicants.length === 1, multiple: false, label: applicantLabel, options: applicantsOptions, value: currentApplicantOption, onChange: handleSelectCurrentItem }), _jsx(TextInput, { label: searchPlaceholder, value: searchValue, onChange: setSearchValue, rightIcon: E_ICONS.SEARCH }), _jsx("span", { className: styles.separator }), _jsx(SelectSection, { className: styles.incompleteIdentityModalSelectReason, list: reasonsLabel, currentFocus: currentReason === null || currentReason === void 0 ? void 0 : currentReason.label, onSelectCurrentItem: handleReasonChange })] })), _jsxs("div", __assign({ className: styles.incompleteIdentityModalActionsWrapper }, { children: [_jsx(Button, { type: EButtonType.NEUTRAL, isEdge: true, label: labelCancelButton, onClick: onCancel }), _jsx(Button, { type: EButtonType.NEUTRAL, label: labelConfirmButton, onClick: handleConfirmIncompleteIdentity, disabled: !!!currentReason, isLoading: isLoading })] }))] })));
};
